import { getBlueprint, getPrintProviderVariants } from '@/api/storesApp/printify';
import { getProduct as getPrintfulProduct } from '@/api/storesApp/printful';
import { PodAssignment } from '@/api/typings/templateProducts';
import { Product } from '@/typings/printful/product';
import { Blueprint } from '@/typings/printify/blueprint';

/**
 * Get the placeholder size for the given POD assignment
 * @param podAssignment POD assignment to use to retrieve the placeholder size
 * @param storeUrl store to use to retrieve the POD data
 * @returns placeholder size in pixels or null if nothing was found
 */
export const getPlaceholderSize = async (
    podAssignment: PodAssignment,
    storeUrl: string
): Promise<{ width: number; height: number } | null> => {
    if (podAssignment.podService === 'printify' && podAssignment.printProviderId) {
        const result = await getPrintProviderVariants(
            Number(podAssignment.productId),
            Number(podAssignment.printProviderId),
            storeUrl,
            true
        );

        const variant = result.variants.find((variant) => variant.id === Number(podAssignment.variantId));
        if (variant) {
            const placeholder = variant.placeholders.find(
                (placeholder) => placeholder.position === podAssignment.placeholderId
            );
            if (placeholder) {
                return {
                    width: Number(placeholder.width),
                    height: Number(placeholder.height)
                };
            }
        }
    }

    return null;
};

export const getProduct = async (
    podAssignment: PodAssignment,
    storeUrl: string
): Promise<Product | Blueprint | null> => {
    if (podAssignment.podService === 'printify') {
        const blueprint = await getBlueprint(Number(podAssignment.productId), storeUrl);
        return blueprint;
    } else if (podAssignment.podService === 'printful') {
        const product = await getPrintfulProduct(podAssignment.productId, storeUrl);
        return product;
    }

    return null;
};
